import React from 'react'
import { useVelaStore } from '../store'

interface SettingsDialogProps {
  onClose: () => void
}

const SettingsDialog: React.FC<SettingsDialogProps> = ({ onClose }) => {
  const settings = useVelaStore(state => state.settings)
  const updateSettings = useVelaStore(state => state.updateSettings)

  const handleUseMockDataChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    updateSettings({ useMockData: e.target.checked })
  }

  const handleBaseUrlChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    updateSettings({ baseUrl: e.target.value })
  }

  const handleLangfuseBaseUrlChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    updateSettings({ langfuseBaseUrl: e.target.value })
  }

  const handleLangfuseDebugModeChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    updateSettings({ langfuseDebugMode: e.target.checked })
  }

  const handleClose = (): void => {
    onClose()
  }

  return (
    <div
      className="settings-dialog"
      style={{
        position: 'absolute',
        top: '50px',
        left: '20px',
        backgroundColor: 'white',
        border: '1px solid var(--vela-border-color)',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '16px',
        zIndex: 1000,
        minWidth: '250px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <h3 style={{ margin: 0 }}>Settings</h3>
        <button
          onClick={handleClose}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          ✕
        </button>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <input
          type="checkbox"
          id="useMockData"
          checked={settings.useMockData}
          onChange={handleUseMockDataChange}
          style={{ marginRight: '8px' }}
        />
        <label htmlFor="useMockData">Use Mock Data</label>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <input
          type="checkbox"
          id="langfuseDebugMode"
          checked={settings.langfuseDebugMode}
          onChange={handleLangfuseDebugModeChange}
          style={{ marginRight: '8px' }}
        />
        <label htmlFor="langfuseDebugMode">Langfuse debug mode</label>
      </div>

      <div
        style={{
          marginBottom: '8px',
        }}
      >
        <label htmlFor="baseUrl" style={{ display: 'block', marginBottom: '4px' }}>
          API Base URL:
        </label>
        <input
          type="text"
          id="baseUrl"
          value={settings.baseUrl}
          onChange={handleBaseUrlChange}
          style={{
            width: '100%',
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid var(--vela-border-color)',
          }}
        />
      </div>

      <div
        style={{
          marginBottom: '8px',
        }}
      >
        <label htmlFor="langfuseBaseUrl" style={{ display: 'block', marginBottom: '4px' }}>
          Langfuse Base URL:
        </label>
        <input
          type="text"
          id="langfuseBaseUrl"
          value={settings.langfuseBaseUrl}
          onChange={handleLangfuseBaseUrlChange}
          style={{
            width: '100%',
            padding: '4px 8px',
            borderRadius: '4px',
            border: '1px solid var(--vela-border-color)',
          }}
        />
      </div>

      <div style={{ fontSize: '12px', color: '#666', marginTop: '16px' }}>
        Settings are automatically saved to localStorage.
      </div>
    </div>
  )
}

export default SettingsDialog
